"use client";

import { useEffect } from "react";
import { registerAllAdapters } from "@/client/adapters";
import { initModelStore, useModelStore } from "@/client/store/modelStore";
import { initAutoDiscovery } from "@/client/config/models.config";
import { useTaskManager } from "@/client/hooks/useTaskManager";

let initialized = false;

const useBootstrapClient = () => {
  useEffect(() => {
    if (initialized) {
      return;
    }
    initialized = true;

    // 立即从 localStorage 恢复任务缓存（同步操作，优先执行）
    useTaskManager.getState().hydrateFromCache();

    const bootstrap = async () => {
      try {
        await initAutoDiscovery();
        registerAllAdapters();
        if (useModelStore.getState().models.length === 0) {
          await initModelStore();
        }
      } catch (error) {
        console.error("[useBootstrapClient] 初始化失败", error);
      }
    };

    void bootstrap();
  }, []);
};

export default useBootstrapClient;
